import React from 'react'

import type { SchemaGroup } from '@/__generated/es-api'
import ErrorMessage from '@/app/component/atom/error-message'
import { FormContainer } from '@/app/component/form/common'
import { useGetGroupLazy } from '@/app/module/groups/hooks/use-get-group-lazy'
import type { PersonalizationType } from '@/app/types'

import CreateSegmentForm from './form/create-segment-form'
import { SegmentFormSkeleton } from './form/update-segment-form'

type Props = {
  personalizationList: PersonalizationType
  segmentId: number
  onExit: () => void
}

const CopySegmentContent: React.FC<Props> = ({ personalizationList, segmentId, onExit }) => {
  const [getGroup] = useGetGroupLazy({ unsubscribe: true })
  const [source, setSource] = React.useState<SchemaGroup | null>()

  React.useEffect(() => {
    let cancelled = false
    const load = async () => {
      const group = Number.isSafeInteger(segmentId) && segmentId > 0 ? await getGroup(segmentId) : undefined
      if (!cancelled) {
        setSource(group?.type === 'SMART' ? group : null)
      }
    }
    load()
    return () => {
      cancelled = true
    }
  }, [segmentId, getGroup])

  if (!source) {
    return (
      <FormContainer>
        {source === undefined ? (
          <SegmentFormSkeleton />
        ) : (
          <ErrorMessage>Unable to load the segment to copy. Close this dialog and try again.</ErrorMessage>
        )}
      </FormContainer>
    )
  }

  return <CreateSegmentForm personalizationList={personalizationList} sourceSegment={source} onExit={onExit} />
}

export default CopySegmentContent
